import Footer from "../../component/Footer/Footer";
import { Navbar } from "../../component/Navbar/NavBar";
import { SpeakersContent } from "./Speakers.content";

export const SpeakersPage = () => {
  return (
    <div className="d-flex flex-column vh-100">
      <Navbar fixedTop={false} />
      <SpeakersContent />
      <Footer />
    </div>
  );
};
